export default __webpack_public_path__ + "static/media/logout.448da9f6.svg";